import React from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  Typography
} from '@material-ui/core';
import { Search, RemoveRedEye, DeleteForever } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../../withRoot';
import fetchData from '../../utils/fetch';
import Loader from '../../components/loader';
import { Link, Route } from 'react-router-dom';
import history from '../../utils/history';
import { find } from 'lodash'
import ItemView from './item';
import 'url-search-params-polyfill';
import TablePaginationActions from '../../components/pagination/CustomPagination';


const styles = theme => ({
  root: {
    textAlign: 'left',
    width: '94%',
    margin: '30px 3%',
  },
  pagination: {
    marginTop: 20,
    color: '#BDBEC0',
    '& div:first-child': {
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
    }
  },
  paper: {
    overflowX: 'auto',
  },
  table: {
    maxWidth: '100%',
    minWidth: 700,
    textAlign: 'center',
    '& tbody tr': {
      verticalAlign: 'top'
    },
    '& tbody td': {
      paddingTop: '10px',
      fontSize: '1rem',
      color: '#191970',
    }
  },
  alignRight: {
    textAlign: 'right'
  },
  textField: {
    width: '100%',
    marginBottom: '20px'
  },
  actions: {
    whiteSpace: 'nowrap',
    '& a': {
      display: 'inline-flex',
      color: '#fff',
      fontSize: '12px',
      lineHeight: '25px',
      alignItems: 'center',
      backgroundColor: '#6495ed',
      padding: '0 8px',
      '&:first-child': {
        backgroundColor: '#add8e6',
        borderRadius: '3px 0 0 3px'
      },
      '&:last-child': {
        backgroundColor: '#fe8368',
        borderRadius: '0 3px 3px 0'
      }
    },
    '& svg': {
      width: '15px',
      height: '15px',
      marginRight: '2px'
    }
  }
});

const tableTitles = [
  {id: 'id', title: 'ID'},
  {id: 'eventId', title: 'Event ID'},
  {id: 'userId', title: 'User ID'},
  {id: 'createdAt', title: 'Notification Time'},
  {id: 'notificationType', title: 'Type'},
];

class MailLogs extends React.Component {
    state = {
      loading: true,
      items: [],
      page: 0,
      total: 0,
      rowsPerPage: 25,
      searchQuery: '',
      order: 'desc',
      orderBy: ''
    };
    componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const search = query.get('search');
      if (search) {
        this.setState({ searchQuery: search });
        this.getSearchResults(search);
      } else {
        this.getData();
      }
    }

    async getData() {
      const data = await fetchData('get', '/mail_logs');
      this.setState({ loading: false, items: await data[0], total: data[1] });
    }

    async deleteItem(id) {
      if (window.confirm(`Are you sure you want to delete mail log ${id}?`)) {
        await fetchData('delete', `/mail_logs/${id}`);
        this.getData();
      }
    }

    handleChangePage = (event, page) => {
      this.getPage(page);
      this.setState({ loading: true, page: page });
      history.push({
        search: `?page=${page}`
      })
    }

    async getPage(pageNumber) {
      const data = await fetchData('get', `/mail_logs?page=${pageNumber + 1}`);
      this.setState({ loading: false, items: await data[0] });
    }

    handleChangeRowsPerPage(event) {
      this.setState({ rowsPerPage: event.target.value })
    }

    async getSearchResults(searchQuery) {
      const data = await fetchData('get', `/_search/mail_logs?query=${searchQuery}`);
      this.setState({ loading: false, items: data[0], total: data[1] });
    }

    updateInputValue = e => { this.setState({ searchQuery: e.target.value }); }

    handleSubmit = (e) => {
      e.preventDefault();
      this.setState({ loading: true });
      const search = this.state.searchQuery;
      this.getSearchResults(search);

      history.push({
        search: `?search=${this.state.searchQuery}`
      })
    }

    handleSort = orderBy => event => {
      let order = 'desc';
      if (this.state.orderBy === orderBy && this.state.order === 'desc') {
        order = 'asc';
      }
      this.setState({ loading: true, orderBy: orderBy, order: order });
      this.getSort(orderBy, order);

      history.push({
        search: `?sort=${orderBy},${order}`
      })

    }

    async getSort(orderBy, order) {
      const data = await fetchData('get', `/mail_logs?sort=${orderBy},${order}`);
      this.setState({ loading: false, items: await data[0] });
    }

    handleItemSave = () => {
      this.setState({ loading: true });
      this.getData();
    }

    viewItem = ({ match: { params: { id } } }) => {
      if (this.state.loading) return null;
      const item = find(this.state.items, { id: Number(id) });

      return <ItemView item={item} find={this.getItem} id={id} lang={this.props.lang}/>
    }

    async getItem(id){
      const data = await fetchData('get', `/mail_logs/${id}`);
      return data[0]
    }

    render() {
        const { classes, match } = this.props;
        const { items, page, rowsPerPage, total, order, orderBy } = this.state;
        return (
          <div className={classes.root}>
            {this.state.loading && (
              <Loader />
            )}
            <Grid container spacing={24} alignItems='center'>
              <Grid item xs={6}>
                <Typography gutterBottom variant="h2" component="h2" style={{'color': '#fdbb2d'}}>
                  MAILLOGS
                </Typography>
              </Grid>
            </Grid>
            <form method="get" action="" onSubmit={this.handleSubmit}>
              <TextField
                id="outlined-name"
                label="Search for Maillog"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                name="search"
                value={this.state.searchQuery}
                onChange={this.updateInputValue}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={this.handleSubmit}
                        aria-label="Search for Maillog"
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </form>
            <Paper className={classes.paper}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    {tableTitles.map( item => {
                      return(
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === item.id}
                            direction={order}
                            onClick={this.handleSort(item.id)}
                           >
                            {item.title}
                          </TableSortLabel>
                        </TableCell>
                      )
                    })}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items
                    .map(row => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.eventId}</TableCell>
                        <TableCell>{row.userId}</TableCell>
                        <TableCell>{row.createdAt}</TableCell>
                        <TableCell>{row.notificationType}</TableCell>
                        <TableCell className='actions'>
                          <Link to={`/maillog/${row.id}`}>
                            <RemoveRedEye/>
                            <span>View</span>
                          </Link>
                          <a onClick={() => this.deleteItem(row.id)} href="#">
                            <DeleteForever/>
                            <span>Delete</span>
                          </a>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <TablePagination
                className={classes.pagination}
                labelDisplayedRows={({ from, to, count }) => 
                  `Showing ${from} - ${to} of ${count} items`}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                page={page}
                onChangePage={this.handleChangePage}
                ActionsComponent = {TablePaginationActions}
              />
            </Paper>
            <Route path="/maillog/:id" render={this.viewItem} />
          </div>
        );
    }
}

export default withRoot(withStyles(styles)(MailLogs));
